import React from "react";
import { Canvas, useThree } from "@react-three/fiber";
import * as THREE from "three";

import Plant from "./Plant";
import "./PlantExperiment3D.css";


function CameraController() {

    const { camera } = useThree();

    React.useEffect(() => {

        camera.position.set(
            6,
            4,
            6
        );

        camera.lookAt(
            new THREE.Vector3(
                0,
                1.5,
                0
            )
        );

    }, [camera]);

    return null;
}


function Ground() {

    return (
        <gridHelper
            args={[
                10,
                20,
                "#26343c",
                "#11191e"
            ]}
            position={[
                0,
                -0.75,
                0
            ]}
        />
    );
}


export default function PlantExperiment3D() {

    return (
        <div className="plant-experiment-3d">

            <Canvas>

                <color
                    attach="background"
                    args={[
                        "#05080a"
                    ]}
                />

                <ambientLight
                    intensity={0.5}
                />

                <directionalLight
                    position={[
                        4,
                        8,
                        4
                    ]}
                    intensity={2}
                />

                <directionalLight
                    position={[
                        -4,
                        4,
                        -4
                    ]}
                    intensity={0.8}
                />

                <CameraController />

                <Plant
                    height={4}
                    leafCount={8}
                    leafSize={1}
                    health={100}
                />

                <Ground />

            </Canvas>

            <div className="plant-overlay">

                <div className="plant-overlay-title">
                    BIOLOGICAL PAYLOAD
                </div>

                <div className="plant-overlay-status">
                    ● NOMINAL
                </div>

            </div>

        </div>
    );
}